"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_set_1 = tslib_1.__importDefault(require("lodash.set"));
var Form = /** @class */ (function () {
    function Form() {
    }
    Form.extractValue = function (element, opts) {
        var _this = this;
        var _a, _b, _c;
        if (element.type === 'field' && !element.options) {
            var elmWithMeta = { name: element.name, label: element.label || element.text, value: element.value, mask: element.mask, priority: element.priority };
            var result = (opts === null || opts === void 0 ? void 0 : opts.withMeta) ? elmWithMeta : element.value;
            return (!opts.onlyGroup || opts.onlyGroup === ((_a = element.priority) === null || _a === void 0 ? void 0 : _a.group)) && result;
        }
        var formOption = element;
        var optionValue = Array.isArray(formOption.optionValue) ? formOption.optionValue.map(function (_a) {
            var id = _a.id;
            return id;
        }) : [formOption.optionValue];
        return Object.assign({}, (_b = formOption
            .options) === null || _b === void 0 ? void 0 : _b.filter(function (option) { return optionValue.includes(option.id); }).reduce(function (accOptions, option) { return lodash_set_1.default(accOptions, option.name, _this.extractValue(tslib_1.__assign(tslib_1.__assign({}, option), { priority: option.priority || formOption.priority }), opts)); }, {}), (_c = formOption
            .fields) === null || _c === void 0 ? void 0 : _c.reduce(function (accFields, field) { return lodash_set_1.default(accFields, field.name, _this.extractValue(tslib_1.__assign(tslib_1.__assign({}, field), { priority: field.priority || formOption.priority }), opts)); }, {}));
    };
    Form.buildFormData = function (event, opts) {
        var _this = this;
        var formData = event
            .steps
            .filter(function (_a) {
            var type = _a.type;
            return type === 'form';
        })
            .flatMap(function (_a) {
            var form = _a.form;
            return _this.extractValue(form, opts);
        })
            .concat((event.subEvents || [])
            .flatMap(function (_a) {
            var cardFields = _a.cardFields;
            return (cardFields || []).reduce(function (obj, cardField) {
                obj[cardField.name] = _this.extractValue(cardField, opts);
                return obj;
            }, {});
        }))
            .reduce(function (obj, values) { return obj = tslib_1.__assign(tslib_1.__assign({}, obj), values); }, opts.onlyGroup ? {} : event.extraFormData || {});
        if (opts && opts.mode === 'iterable')
            return Object.values(formData).filter(function (prop) { return Object.keys(prop).length && Object.values(prop).some(function (elm) { return Object.values(elm)[0] !== false; }); });
        else
            return formData;
    };
    return Form;
}());
exports.Form = Form;
//# sourceMappingURL=form.js.map